import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useConfig } from "@/contexts/cdpConfig";
import { useContactContext, usePlatoAvailable, useStickyContact, } from "@/contexts/contact";
import { useI18n, useIsNewBuildProject } from "@/shared/hooks";
import { useContactingTestId, useCustomerAction } from "@/hooks";
import { EnvelopeIcon } from "@gemini/icons";
import { Button } from "@gemini/ui";
import { BookVisitButton } from "../Buttons";
import { PhoneCTA } from "../Buttons/PhoneButton";
import { StickyContactWrapper } from "./ui";
const EmailModalButton = ({ ...props }) => {
    var _a;
    const dataTestId = useContactingTestId("StickyCta");
    const { t } = useI18n();
    const { phoneNumbers = [] } = (_a = useStickyContact()) !== null && _a !== void 0 ? _a : {};
    const isPreviewMode = useConfig().previewMode;
    const isProject = useIsNewBuildProject();
    const hasNoPhone = phoneNumbers.length === 0;
    const { customerActionExposeInteraction } = useCustomerAction();
    const emailModalBtnText = isProject
        ? t("contact.form.project.email")
        : t(hasNoPhone ? "contact.card.email" : "contact.mobile_sticky.email");
    return (_jsx(Button, { ...props, testId: `${dataTestId}.email`, variant: "primary", icon: EnvelopeIcon, iconPosition: "start", isFullWidth: true, onPress: () => {
            if (isPreviewMode)
                return;
            customerActionExposeInteraction([
                { key: "interaction", value: "openContactForm" },
            ]);
            props.onPress();
        }, isDisabled: isPreviewMode, children: emailModalBtnText }));
};
export const StickyCta = ({ tracking, variant = "light" }) => {
    var _a, _b, _c;
    const { t } = useI18n();
    const dataTestId = useContactingTestId("StickyCta");
    const { toggleModal } = useContactContext();
    const { phoneNumbers = [] } = (_c = (_b = (_a = useContactContext()) === null || _a === void 0 ? void 0 : _a.contactSections) === null || _b === void 0 ? void 0 : _b.mobilePhones) !== null && _c !== void 0 ? _c : {};
    const { avZone } = tracking;
    const isPlatoAvailable = usePlatoAvailable();
    const handlePress = () => {
        toggleModal({
            av_zone: avZone,
            legacyTrackingInfos: "detail-responsive", //tracking GA3 for harvest (sticky = responsive)
        });
    };
    return (_jsxs(StickyContactWrapper, { testId: dataTestId, variant: variant, children: [_jsx(PhoneCTA, { trackingAvZone: avZone, legacyTrackingInfos: "detail-responsive" //tracking GA3 for harvest (sticky = responsive)
                , rootTestId: `${dataTestId}`, phoneNumbers: phoneNumbers, variant: "primary", iconOnly: isPlatoAvailable, size: "48", children: t("contact.mobile_sticky.phone") }), isPlatoAvailable && (_jsx(BookVisitButton, { av_zone: avZone, rootTestId: dataTestId, variant: variant === "light" ? "secondary" : "secondary-inverted", children: t("contact.cta.book_visit") })), _jsx(EmailModalButton, { onPress: handlePress })] }));
};
